import { FunctionComponent } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: contents;
`;

export const DslProvider: FunctionComponent = ({ children }) => {
  return (
    <Container className='dsl'>{children}</Container>
  );
};

export default DslProvider;
